export default function Footer() {
    return <footer className='App-footer'>
        <p>© 2022 RFD Micro Electricity Co., Ltd. All rights reserved.</p>
    </footer>   
}